import { render, staticRenderFns } from "./ViewParams.vue?vue&type=template&id=5c4b1d44&scoped=true"
import script from "./ViewParams.vue?vue&type=script&lang=js"
export * from "./ViewParams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4b1d44",
  null
  
)

export default component.exports